// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { HamQuest } from '../../../App';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Page from '../pageLayout/Page';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Button from '../../_common/form/Button';

const Message = styled.div`
    text-align: center;
    padding: 20px;
    font-size: 1.1em;
    line-height: 1.6;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

const FamilyPlanConfirmation = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');
    const { state: { active_user } } = useGlobalState();

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Invalid confirmation link. No token provided.');
            return;
        }

        // Call the API to confirm the family plan
        HamQuest.get(QuestRoute.user.confirmFamilyPlan(token))
            .then(() => {
                setStatus('success');
                setMessage('Family plan successfully confirmed! You can now enjoy your family plan benefits.');
            })
            .catch((error) => {
                setStatus('error');
                setMessage(error.blob || 'Failed to confirm family plan. The link may be expired or invalid.');
            });
    }, [token]);

    if (status === 'loading') {
        return (
            <Page title='Confirming Family Plan' icon='userFriends'>
                <Loading />
                <Message>Please wait while we confirm your family plan...</Message>
            </Page>
        );
    }

    if (status === 'success') {
        return (
            <Page title='Success!' icon='checkCircle'>
                <Message>{message}</Message>
                <ButtonContainer>
                    {active_user.isLoggedIn ? (
                        <Button to='/userManagement'>Go to Account</Button>
                    ) : (
                        <Button to='/'>Go Home</Button>
                    )}
                </ButtonContainer>
            </Page>
        );
    }

    return (
        <Page title='Confirmation Failed' icon='exclamationTriangle'>
            <Message>{message}</Message>
            <ButtonContainer>
                <Button to='/'>Go Home</Button>
            </ButtonContainer>
        </Page>
    );
};

export default FamilyPlanConfirmation;